<template>
  <div class="welfare">
    <div class="xiao_title">生活全品类供应链资源输出</div>
    <div class="Tdescribe">700000+ SKU总量 3000+ TOP品牌  全国多仓直发网络布局  完美售后客服体系建设 </div>
    <div class="center wrapW">
      <div class="left">
        <img src="~@/assets/img/welfareTLogo.png">
        <div class="info">
          <div class="title">平台直接供应商</div>
        </div>
      </div>
      <div class="iconfont icon-jia"></div>
      <img src="~@/assets/img/welfareT2.png">
      <div class="iconfont">&#xe7fb;</div>
      <div class="right">
        <img src="~@/assets/img/welfareT3Logo.png" class="welfareT3Logo"><br>
        <img src="~@/assets/img/welfareT3.png">
        <div class="rightP">
          <p>700000+SKU总量</p>
          <p>2000+品牌供应商</p>
          <p>全国多仓直发网络</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'welfareT',
  data () {
    return {
    }
  }
}
</script>
<style lang="stylus" scoped>
.welfare
  text-align center
  padding .25rem 0
  margin-top .8rem
  .Wdescribe
    font-size .24rem
    margin-top .22rem
    color #666
    letter-spacing .04rem
  .center
    display flex
    justify-content space-between
    align-items center
    margin-top .61rem
    .left
      width 7.4rem
      height 3.4rem
      position relative
      overflow hidden
      img
        height 100%
        position absolute
        top 0
        left 0
        animation slideshow 20s linear infinite
        transform translate3d(0, 0, 0)
        @keyframes slideshow
          0%
            transform translateX(0%)
          50%
            transform translateX(-37%)
          100%
            transform translateX(0%)
    ul
      width 100%
      height 3.5rem
      background #000
      box-shadow 0px 0px 10px 0px rgba(9, 9, 9, 0.2)
    .info
      background-image url('~@/assets/img/welfareT1.png')
      background-repeat no-repeat
      background-size 100% 100%
      width 76%
      position absolute
      top 10%
      left 12%
      height 80%
      text-align center
      .title
        width 100%
        font-size .24rem
        color #D22016
        margin-bottom .19rem
        font-weight 400
        margin-top 20%
    .right
      position relative
      .welfareT3Logo
        margin-bottom .19rem
        margin-left .5rem
      .rightP
        color #D22016
        font-size .16rem
        font-weight bold
        position absolute
        top 60%
        width max-content
        left 50%
        transform translate(-40%,-50%)
        text-shadow 4px 4px 0 white, 4px -4px 0 white, -4px -4px 0 white, -4px 4px 0 white, 4px 3px 0 white, 4px -3px 0 white, -4px -3px 0 white, -4px 3px 0 white, 4px 2px 0 white, 4px -2px 0 white, -4px -2px 0 white, -4px 2px 0 white, 4px 1px 0 white, 4px -1px 0 white, -4px -1px 0 white, -4px 1px 0 white, 4px 0px 0 white, 4px 0px 0 white, -4px 0px 0 white, -4px 0px 0 white, 3px 4px 0 white, 3px -4px 0 white, -3px -4px 0 white;
</style>



// WEBPACK FOOTER //
// src/pages/index/components/welfareT.vue